/**
 * Chat SSE API服务
 *
 * 提供Chat消息的SSE流式通信，替代WebSocket进行流式聊天。
 */

import type { ChatMessageSend } from '../types/chat';
import { createSSEStream, SSEError, type SSEEvent } from './sseStream';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '';

export { SSEError, SSEEvent };

export class ChatApiService {
  private baseUrl: string;

  constructor(baseUrl: string = API_BASE_URL) {
    this.baseUrl = baseUrl;
  }

  async *sendMessageStream(
    sessionId: string | undefined,
    request: ChatMessageSend,
    signal?: AbortSignal
  ): AsyncGenerator<SSEEvent> {
    const url = sessionId
      ? `${this.baseUrl}/api/chat/sessions/${sessionId}/message`
      : `${this.baseUrl}/api/chat/message`;

    yield* createSSEStream(url, request, signal);
  }
}

export const chatApi = new ChatApiService();